// extracted by mini-css-extract-plugin
export default {"imageWrapper":"personCard_imageWrapper__o1kSj","avatar":"personCard_avatar__NX1nh","name":"personCard_name__FCJit","description":"personCard_description__xpGkl"};